var $ = require('jquery');
var stats = require('stats/stats')
var hitSent = false;
if (!hitSent) {
    $(function () {
        var $el = $('[data-newsitem-id][data-newsitem-type]'),
            id = $el.data('newsitem-id'),
            type = $el.data('newsitem-type');
        if (id && type) {
            var language = readActLang("django_language")
            $.post('/'+ language + '/newsitemhit/', {id: id, type: type});
            hitSent = true;
       }
    });
}



//////////////////
// WEBPACK FOOTER
// /srv/mestis/mestis.git/liiga/static/liiga/site/js/newsitemhit.js
// module id = 13
// module chunks = 0